var map = {
	"./BBg.png": 6653,
	"./BBird.png": 1481,
	"./BBlueCar.png": 9588,
	"./BCbush.png": 1587,
	"./BGbush.png": 2751,
	"./BRedCar.png": 9449,
	"./BYellowCar.png": 3736,
	"./Btree.png": 2704,
	"./clappingHands.webm": 5134,
	"./final_sample_he.png": 6015,
	"./logo.png": 3153,
	"./logo144.png": 1948,
	"./logo152.png": 3553,
	"./logo16.png": 8784,
	"./logo192.png": 21,
	"./logo32.png": 6366,
	"./logo512.png": 5641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;